import { render, staticRenderFns } from "./MetabaseCard.vue?vue&type=template&id=31cb1204&scoped=true&"
import script from "./MetabaseCard.vue?vue&type=script&lang=js&"
export * from "./MetabaseCard.vue?vue&type=script&lang=js&"
import style0 from "./MetabaseCard.vue?vue&type=style&index=0&id=31cb1204&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31cb1204",
  null
  
)

export default component.exports